export default "__VITE_ASSET__7c8b886f__"